export default __webpack_public_path__ + "static/media/bg_1990.9c3ba906.png";